import { RootState } from "../../store";

export const selectIsIdea = (state: RootState) => state.isIdea;